import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-component',{attrs:{"contentPadding":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c(VSkeletonLoader,{attrs:{"boilerplate":"","type":"article, actions@1"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }